import React from 'react';
import map from 'mn-utils/map';
import {
  USER_TYPE_MERCHANT,
  USER_TYPE_CUSTOMER, USER_TYPE_PARTNER,
} from '../../../../constants';
import {
  LINK_DASHBOARD,
  LINK_TRANSACTIONS,
  LINK_MANAGEMENT,
  LINK_DEVELOPER_OPTIONS,
  LINK_SETTINGS,
  LINK_HELP, LINK_PAYMENTS, LINK_ROLLING_RESERVE,
} from '../../../../constants/links';
import {
  Link,
  path$,
} from '../../../../router';
import withState from '../../../../utils/withState';
import {
  account$,
} from '../../../../emitters/account';
import Ripple from '../../../dumb/Ripple';


module.exports = withState(() => {
  const linksOfMerchant = [
    {
      id: 'dashboard',
      name: 'Dashboard',
      link: LINK_DASHBOARD,
      icon: require('./icons/Dashboard'),
    },
    {
      id: 'payments',
      name: 'Payments',
      link: LINK_PAYMENTS,
      icon: require('./icons/Transactions'),
    },
    {
      id: 'trx',
      name: 'Transactions',
      link: LINK_TRANSACTIONS,
      icon: require('./icons/Invoices'),
    },
    {
      id: 'rollingReserve',
      name: 'Rolling Reserve',
      link: LINK_ROLLING_RESERVE,
      icon: require('./icons/RollingReserve'),
    },
    {
      id: 'devOptions',
      name: 'Developer options',
      link: LINK_DEVELOPER_OPTIONS,
      icon: require('./icons/DeveloperOptions'),
    },

    {separator: 1},

    {
      id: 'settings',
      name: 'Settings',
      link: LINK_SETTINGS,
      icon: require('./icons/Settings'),
    },
    // {
    //   name: 'Help and support',
    //   link: LINK_HELP,
    //   icon: require('./icons/Help'),
    // },
  ];

  const linksOfCustomer = [
    {
      id: 'trx',
      name: 'Transactions',
      link: LINK_TRANSACTIONS,
      icon: require('./icons/Transactions'),
    },
    {
      id: 'settings',
      name: 'Settings',
      link: LINK_SETTINGS,
      icon: require('./icons/Settings'),
    },

    {separator: 1},

    {
      id: 'help',
      name: 'Help and support',
      link: LINK_HELP,
      icon: require('./icons/Help'),
    },
  ];

  const NAV_MAP = {
    [USER_TYPE_MERCHANT]: linksOfMerchant,
    [USER_TYPE_PARTNER]: linksOfMerchant,
    [USER_TYPE_CUSTOMER]: linksOfCustomer,
  };

  return (state, props) => {
    const {
      path,
    } = state;


    const account = state.account || {};

    const links = account && NAV_MAP[account.role] || [];

    function isActive(item) {
      const link = item.link;
      return item.strict
        ? link === path
        : path.startsWith(link);
    }

    return (
      <div
        className={
          `pt55 pb20 ml-10 ml0.compact pt25@m`
          + (props.compactView ? ' compact' : '')
        }
      >
        {map(links, (item, i) => {
          if (item.separator) {
            return (
              <div
                key={i}
                className={
                  `h44 pt5 layoutRow fhaC fvaC pl20 pr40 pr0@m p0.compact`
                  + (props.compactView ? ' compact' : '')
                }
              >
                <div className="h1 bgDADCE1 w"/>
              </div>
            );
          }
          const {
            disabled,
          } = item;
          const Icon = item.icon;
          const active = isActive(item);

          return (
            <div key={i}>
              <Ripple
                component={disabled ? 'div' : Link}
                className={
                  `layoutRow fhaS fvaC rlv h48 pl10 f18 lh tdN fw3 dn
                  ff$2 usN c717275 c3:not[.active]:not[.disabled]:h
                  (c5B47FF|fw7).active (ml0|pl0).compact o50.disabled`
                  + (active ? ' active' : '')
                  + (props.compactView ? ' compact' : '')
                }
                disabled={disabled}
                href={disabled ? null : (item.link || '')}
                onClick={props.onClick ? props.onClick : null}
                data-testid={`${item.id}Link`}
                activeAsParent
              >
                <div
                  className={
                    `dN dB<1.active abs st50% xY-50% sr-20 bs bcF0 bclF6F6F6 b bl20 bv26 dN<1.active@m
                    (bcl5B47FF|bv24).compact`
                    + (props.compactView ? ' compact' : '')
                  }
                />
                <div
                  className={
                    `layoutRow fhaC fvaC sq34 mr9 r ov w16>1 
                    (cF|bg5B47FF)<1.active
                    (w|h|r0|m0).compact`
                    + (props.compactView ? ' compact' : '')
                  }
                >
                  {Icon ? (<Icon/>) : null}
                </div>
                <div
                  className={
                    `rlv st-1 ff$3 dN.compact`
                    + (props.compactView ? ' compact' : '')
                  }
                >{item.name}</div>
              </Ripple>
            </div>
          );
        }, [])}
      </div>
    );
  };
}, {
  path: path$,
  account: account$,
});
